module.exports = __webpack_public_path__ + "img/premium2.8057d021.png";